import { withStylePrefix } from '../common/withStylePrefix';
import { LinkThumbnailComponent, linkThumbnailTemplate } from './LinkThumbnail';
import styles from './LinkThumbnail.styles.scss';
export const linkThumbnailDefinition = {
    baseName: 'link-thumbnail',
    template: linkThumbnailTemplate,
    styles: withStylePrefix(styles),
};
export const chameleonLinkThumbnail = LinkThumbnailComponent.compose(linkThumbnailDefinition);
